import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { i18n } from "@/i18n";
import "@/common/filters";
import ActionCableVue from "actioncable-vue";
import Zendesk from "@/services/zendesk";
import '@splidejs/splide/dist/css/splide.min.css';
import vuetify from './plugins/vuetify'
import gtmPlugin from './plugins/gtm';
import { initPosthog, captureException } from './plugins/posthog';
import { Laue } from 'laue';
import axios from 'axios';

initPosthog(router);

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: "error",
  connectImmediately: false,
});

Vue.use(Cropper);
Vue.use(gtmPlugin);
Vue.use(Laue);

Vue.config.productionTip = false;

Vue.config.errorHandler = async (err, vm, info) => {
  console.error(err);
  captureException(err, { vue_info: info, vue_component: vm?.$options?.name });

  if (err?.message?.includes(`undefined (reading 'p')`))
    return;

  if (vm.$options.name !== 'Results' && vm.$options.name !== 'CheckoutView') {
    return;
  }
 
  try {
    const response = await axios.post('https://chat.googleapis.com/v1/spaces/AAQArE9eoEc/messages', {
      text: `
        Environment: ${process.env.NODE_ENV}
        Error: ${err.message}
        Info: ${info}
        VM: ${vm.$options.name}`,
    }, {
      params: {
        key: process.env.VUE_APP_GOOGLE_CHAT_API_KEY,
        token: process.env.VUE_APP_GOOGLE_CHAT_API_TOKEN,
      },
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    })

    console.log(response);
  } catch (error) {
    console.error(error);
  }
};

new Vue({
  router,

  provide: {
    Zendesk,
  },

  store,
  i18n,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");
